import React from "react";
import { Filter } from "./FeedFilter";
import { FilterButton } from "./FilterButton";
import { useFilterContext } from "./State/FilterContext";
import { useFilterDispatchContext } from "./State/FilterDispatchContext";
import { ThemeProvider } from "@material-ui/core";
import { filterTheme } from "../styles/FilterTheme";

export const FilterPanelTitle = "AI focus";

interface FilterPanelProps {
  variant: "modal" | "column";
  onClose?: () => void;
}

export const FilterPanel = (props: FilterPanelProps) => {
  const { variant } = { ...props };
  const { filterMode } = useFilterContext();
  const { setFilterMode } = useFilterDispatchContext();

  return (
    <ThemeProvider theme={filterTheme}>
      <div
        className={variant === "modal" ? "" : "border-app-slateblue border-t-8"}
      >
        <div
          className={
            variant === "modal"
              ? ""
              : "border-app-gray-08 border border-l-2 border-r-2 rounded rounded-t-none w-full"
          }
        >
          {variant === "column" && (
            <div className="h-18 border-app-gray-08 border-b-2 w-full px-4 flex items-center bg-app-slateblue-x-light">
              <div className="text-display-title text-color-secondary flex-grow">
                {FilterPanelTitle}
              </div>
              <div>
                <FilterButton
                  className="point-on-hover"
                  variant={filterMode === "edit" ? "contained" : "outlined"}
                  color="slateblue"
                  fontSize={40}
                  onClick={() =>
                    setFilterMode(filterMode === "edit" ? "saved" : "edit")
                  }
                  aria-label={
                    filterMode === "edit"
                      ? "Show saved filters"
                      : "Edit current filter"
                  }
                />
              </div>
            </div>
          )}
          <Filter onClose={props.onClose} />
        </div>
      </div>
    </ThemeProvider>
  );
};
